<template>
  <div v-if="isExternalLink">
    <!-- <span @click="onClickSidebar($event)" :class="classList"> -->
    <router-link @click.native="onClickSidebar($event)" :to="url" :class="classList">
       <!-- <i :class="icon"></i> {{name}} -->
      <img :src="src"> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
    </router-link>
  <!-- </span> -->
  </div>
  <div v-else>
    <!-- <span @click="onClickSidebar($event)" :class="classList"> -->
    <router-link @click.native="onClickSidebar($event)" :to="url" :class="classList">
      <!-- <i :class="icon"></i> {{name}} -->
      <img :src="src"> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
    </router-link>
    <!-- </span> -->
  </div>
</template>

<script>
  export default {
    name: 'sidebar-nav-link',
    props: {
      name: {
        type: String,
        default: ''
      },
      url: {
        type: String,
        default: ''
      },
      src: {
        type: String,
        default: ''
      },
      badge: {
        type: Object,
        default: () => {}
      },
      variant: {
        type: String,
        default: ''
      },
      classes: {
        type: String,
        default: ''
      }
    },
    computed: {
      classList () {
        return [
          'nav-link',
          this.linkVariant,
          ...this.itemClasses
        ]
      },
      linkVariant () {
        return this.variant ? `nav-link-${this.variant}` : ''
      },
      itemClasses () {
        return this.classes ? this.classes.split(' ') : []
      },
      isExternalLink () {
        if (this.url.substring(0, 4) === 'http') {
          return true
        } else {
          return false
        }
      }
    },
    beforeRouteLeave (to, from, next) {
      console.log('beforeRouteLeave')
      if (window.confirm('Leave?')) {
        next()
      } else {
        next(false)
      }
    },
    methods: {
      onClickSidebar: function (evt) {
        // evt.preventDefault(evt)
        // console.log(this.$route.params)
        // console.log(this.url)
        const $t = this.$t
        if (this.$route.params.item) {
          this.$swal({
            title: $t('popTitleStrType'),
            text: $t('confirmInputDeleteStr'),
            showCancelButton: true,
            cancelButtonColor: '#f64846',
            type: 'warning',
            confirmButtonClass: 'btn btn-success',
            cancelButtonClass: 'btn btn-danger',
            reverseButtons: false,
            animation: false,
            customClass: 'animated fadeInUp',
            // customClass: 'animated flipInX',
            width: '35rem',
            position: 'center',
            // toast: true,
            allowOutsideClick: false,
            padding: '2rem'
            // timer: 3000
          }).then((result) => {
            if (result.value) {
              this.$router.push(this.url)
            } else {
              console.log('false')
            }
          })
        } else {
          console.log('false')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarNavLink.vue